import { render, staticRenderFns } from "./AccountsDetailsData.vue?vue&type=template&id=381450cb&scoped=true&"
import script from "./AccountsDetailsData.vue?vue&type=script&lang=js&"
export * from "./AccountsDetailsData.vue?vue&type=script&lang=js&"
import style0 from "./AccountsDetailsData.vue?vue&type=style&index=0&id=381450cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381450cb",
  null
  
)

export default component.exports